import Component from './Component';

export default class StickyNav extends Component {
  load() {
    this.initStickyNav();

    super.load();
  }

  initStickyNav() {
    // const stickyNav = document.getElementById('sticky-nav');
    // if (stickyNav) {

    // $(stickyNav).show();  // Replaced show with simple CSS & breakpoint

    /*$(window).on('scroll load', () => {
      const bodyHeight = document.body.clientHeight;

      if ( // If we're within 100px of the top or bottom of the page
        ($(window).scrollTop() + $(window).height() >= bodyHeight - 100) ||
        ($(window).scrollTop() <= 100)
      ) {
        $(stickyNav).fadeOut();
      } else {
        $(stickyNav).fadeIn();
      }
    });*/
    // }
  }
}
